module.exports = __webpack_public_path__ + "fonts/fontawesome/fa-brands-400.woff2";